import { axiosRetry } from '@/plugins/axios';

const base = '/orders';

export function createOrder(payload, cfg = {}) {
    return axiosRetry.post(`${base}`, payload, {
        timeout: 150000,
        ...cfg
    });
}

export function getOrder(id, venueId, cfg = {}) {
    return axiosRetry.get(`${base}/${id}?venueId=${venueId}`, {
        ...cfg
    });
}
